module.exports = __webpack_public_path__ + "media/images/swifticons/weather-partly-sunny-comment-bc86224380a04b4f679bf472955f4ab6.svg";